import { render } from "./adRegDate.vue?vue&type=template&id=069a68f8&scoped=true"
import script from "./adRegDate.vue?vue&type=script&lang=js"
export * from "./adRegDate.vue?vue&type=script&lang=js"

import "./adRegDate.vue?vue&type=style&index=0&id=069a68f8&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069a68f8"]])

export default __exports__